import React, {
  useEffect,
  useRef,
} from "react";

import "./MessageList.css";

import Message from "./Message";

export default function MessageList({
  messages = [],
  client,
}) {
  const bottom =
    useRef(null);

  useEffect(() => {
    bottom.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages]);

  const currentUserId =
    client?.getUserId?.();

  return (
    <div className="chat-messages">

      {messages.length === 0 ? (

        <div className="chat-messages__empty">

          <div>
            Сообщений пока нет
          </div>

          <span>
            Начните переписку
          </span>

        </div>

      ) : (

        messages.map(
          (event, index) => {

            const sender =
              event?.getSender?.();

            const isOwn =
              sender === currentUserId;

            return (
              <Message
                key={
                  event.getId?.() ||
                  index
                }
                event={event}
                client={client}
                isOwn={isOwn}
              />
            );
          }
        )

      )}

      <div ref={bottom} />

    </div>
  );
}